<template>
  <md-card class="card-content">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">
          {{ $t("score_report.student.block_terms_detail_title") }}
        </h4>
      </div>
    </md-card-header>
    <md-card-content>
      <template v-if="hasTableData">
        <md-card
          v-for="(termGrades, termName) in courseGradesTableData"
          :key="termName"
        >
          <md-card-content>
            <p class="text-xl font-medium">Term: {{ termName }}</p>
            <md-table :value="termGrades">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <template v-if="item.isAggregationRow">
                  <md-table-cell
                    :md-label="
                      $t('score_report.student.cgrade_table_col_class_name')
                    "
                    ><span class="font-medium">
                      {{ item.title }}</span
                    ></md-table-cell
                  >
                  <md-table-cell
                    :md-label="$t('common.subject')"
                  ></md-table-cell>
                  <md-table-cell
                    :md-label="
                      $t('score_report.student.cgrade_table_col_class_weight')
                    "
                  ></md-table-cell>
                  <md-table-cell
                    :md-label="
                      $t('score_report.student.cgrade_table_col_class_credits')
                    "
                  ></md-table-cell>
                  <md-table-cell
                    :md-label="
                      $t('score_report.student.cgrade_table_col_class_points')
                    "
                  ></md-table-cell>
                  <md-table-cell
                    :md-label="
                      $t(
                        'score_report.student.cgrade_table_col_class_bonus_point'
                      )
                    "
                    >{{ item.value }}</md-table-cell
                  >
                  <md-table-cell
                    :md-label="
                      $t(
                        'score_report.student.cgrade_table_col_class_final_score'
                      )
                    "
                  ></md-table-cell>
                  <md-table-cell
                    :md-label="$t('score_report.student.area_grade_letter')"
                  ></md-table-cell>
                </template>
                <template v-else>
                  <md-table-cell
                    :md-label="
                      $t('score_report.student.cgrade_table_col_class_name')
                    "
                    >{{ item.name }}</md-table-cell
                  >
                  <md-table-cell :md-label="$t('common.subject')">
                    {{ item.subject }}
                  </md-table-cell>
                  <md-table-cell
                    :md-label="
                      $t('score_report.student.cgrade_table_col_class_weight')
                    "
                    >{{ item.real_weight }}</md-table-cell
                  >
                  <md-table-cell
                    :md-label="
                      $t('score_report.student.cgrade_table_col_class_credits')
                    "
                    >{{ item.credits }}</md-table-cell
                  >
                  <md-table-cell
                    :md-label="
                      $t('score_report.student.cgrade_table_col_class_points')
                    "
                    >{{ item.point }}</md-table-cell
                  >
                  <md-table-cell
                    :md-label="
                      $t(
                        'score_report.student.cgrade_table_col_class_bonus_point'
                      )
                    "
                    >{{ item.bonus_point }}</md-table-cell
                  >
                  <md-table-cell
                    :md-label="
                      $t(
                        'score_report.student.cgrade_table_col_class_final_score'
                      )
                    "
                    >{{ item.final_score }}</md-table-cell
                  >
                  <md-table-cell
                    :md-label="$t('score_report.student.area_grade_letter')"
                    >{{ item.grade_letter }}</md-table-cell
                  >
                </template>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </template>
      <no-data-found class="mx-auto" v-else></no-data-found>
    </md-card-content>
  </md-card>
</template>

<script>
import NoDataFound from "@/components/Base/Illustration/NoDataFound.vue";
export default {
  name: "course-grades-table",
  components: { NoDataFound },
  props: ["courseGrades"],
  computed: {
    courseGradesTableData() {
      return this.generateTableRowsFrom(this.courseGrades);
    },

    hasTableData() {
      return (
        this.courseGradesTableData &&
        Object.keys(this.courseGradesTableData).length
      );
    }
  },
  methods: {
    generateTableRowsFrom(courseGrades) {
      if (!courseGrades) return {};

      return courseGrades.reduce((tableRows, courseGrade) => {
        tableRows[courseGrade.term_name] = this.generateRowsFrom(courseGrade);

        return tableRows;
      }, {});
    },

    generateRowsFrom(courseGrade) {
      // const termNameRow = this.generateSectionHeader(courseGrade.term_name);
      const classRows = courseGrade.classes;
      const earnedGPARow = this.generateAggregationRow(
        "Earned GPA",
        courseGrade.total?.earned_gpa
      );
      const earnedCreditRow = this.generateAggregationRow(
        "Earned credits",
        courseGrade.total?.earned_credits
      );

      return [...classRows, earnedGPARow, earnedCreditRow];
    },

    generateSectionHeader(title) {
      return {
        title,
        isHeaderRow: true
      };
    },

    generateAggregationRow(title, value) {
      return {
        title,
        value,
        isAggregationRow: true
      };
    }
  }
};
</script>

<style lang="scss" scoped>
// thead tr * {
//   font-weight: 600 !important;
// }
</style>
